











import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const shopHomeModule = namespace('shopHome')

@Component
export default class Time extends Vue {
  @shopHomeModule.State shopDetail!: any
  get timeDaily() {
    let arr = this.shopDetail ? this.shopDetail.storeTimeArr : []
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    Array.isArray(arr) &&
      arr.map(x => {
        // eslint-disable-next-line @typescript-eslint/no-extra-semi
        ;(x.day = Object.keys(x)[0]), (x.time = Object.values(x)[0])
      })
    return arr
  }
}
